import Footer from 'components/Footer';
import { AppLayout } from './AppLayout';
import Navigation from 'components/Navigation';
import Head, { HeadProps } from 'features/core/Head';

interface LayoutProps extends HeadProps {
  children: React.ReactNode;
  isProd?: boolean;
}

const Layout: React.FC<LayoutProps> = props => {
  const { children, isProd = false, ...headProps } = props;

  return (
    <>
      <Head {...headProps} isProd={isProd} addFull addOg />
      <AppLayout>
        <Navigation />
        <main>{children}</main>
        <Footer />
      </AppLayout>
    </>
  );
};

export default Layout;
